module.exports = {"230104001":"靖宇街道","230104002":"太古街道","230104003":"东莱街道","230104004":"滨江街道","230104005":"仁里街道","230104006":"南市街道","230104007":"崇俭街道","230104008":"振江街道","230104009":"东原街道","230104010":"大兴街道","230104011":"胜利街道","230104012":"南马街道","230104021":"民强街道","230104022":"大有坊街道","230104023":"南直路街道","230104024":"化工街道","230104025":"火车头街道","230104026":"新一街道","230104027":"三棵树大街街道","230104028":"水泥路街道","230104029":"太平大街街道","230104030":"黎华街道","230104031":"新乐街道","230104102":"永源镇","230104109":"巨源镇","230104111":"团结镇","230104112":"民主镇","230104500":"青年农场","230104579":"道外农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230104.json
// module id = 674
// module chunks = 0